import { DataType } from "components/formatted-value";
import { SelectValue } from "components/select/select";
import { Project } from "containers/Projects/projects";

import { FieldsGroup, FieldType } from "../../fields.d";

export type ImagesFormInputs = {
  project: Project[];
  language: SelectValue;
  file: File;
  alt: string;
};

export enum ImagesField {
  Language = "language",
  Project = "project",
  Url = "url",
  OriginalName = "originalName",
  Alt = "alt",
  CreatedAt = "createdAt",
  CreatedBy = "createdBy",
  UpdatedAt = "updatedAt",
  UpdatedBy = "updatedBy",
  File = "file",
}

export const IMAGES_FIELDS: FieldsGroup[] = [
  {
    id: ImagesField.Project,
    label: "",
    fields: [
      {
        id: ImagesField.Project,
        label: "Projekt",
        span: 6,
        type: FieldType.ProjectsSelect,
        dataType: DataType.Projects,
        show: { visible: true, accessor: ["project", "name"] },
        create: { visible: true },
        update: { visible: true },
      },
      {
        id: ImagesField.Language,
        label: "Wersja językowa",
        span: 6,
        type: FieldType.ProjectLanguagesSelect,
        dataType: DataType.Language,
        show: { visible: true },
        create: { visible: true, required: true },
        update: { visible: true, required: true },
        caption: "Lista zawiera języki przypisane do wybranego projektu",
      },
    ],
  },
  {
    id: "basic",
    label: "Podstawowe informacje",
    fields: [
      {
        id: ImagesField.OriginalName,
        label: "Nazwa i rozszerzenie",
        type: FieldType.Input,
        span: 6,
        show: { visible: true },
        create: { visible: false },
        update: { visible: false },
      },
      {
        id: ImagesField.Alt,
        label: "Tekst alternatywny",
        type: FieldType.Input,
        span: 6,
        show: { visible: true },
        create: { visible: false },
        update: { visible: false },
      },
      {
        id: ImagesField.Alt,
        label: "Tekst alternatywny",
        type: FieldType.Input,
        span: 12,
        show: { visible: false },
        create: { visible: true, required: true },
        update: { visible: true, required: true },
      },
      {
        id: ImagesField.Url,
        label: "Grafika",
        type: FieldType.Image,
        span: 12,
        show: { visible: true },
        create: { visible: false },
        update: { visible: false },
      },
      {
        id: ImagesField.File,
        label: "Grafika",
        type: FieldType.ImageCropper,
        span: 12,
        imageRequirements: { allowVectors: true },
        show: { visible: false },
        create: { visible: true, required: true },
        update: { visible: false },
      },
    ],
  },
  {
    id: "system",
    label: "Dane systemowe",
    fields: [
      {
        id: ImagesField.CreatedAt,
        label: "Utworzenie",
        span: 3,
        type: FieldType.Input,
        dataType: DataType.DateTime,
        show: { visible: true },
        create: { visible: false },
        update: { visible: false },
      },
      {
        id: ImagesField.CreatedBy,
        label: "Utworzono przez",
        span: 3,
        type: FieldType.UserFullName,
        dataType: DataType.Users,
        show: { visible: true },
        create: { visible: false },
        update: { visible: false },
      },
      {
        id: ImagesField.UpdatedAt,
        label: "Ostatnia aktualizacja",
        span: 3,
        type: FieldType.Input,
        dataType: DataType.DateTime,
        show: { visible: true },
        create: { visible: false },
        update: { visible: false },
      },
      {
        id: ImagesField.UpdatedBy,
        label: "Zaktualizowano przez",
        span: 3,
        type: FieldType.UserFullName,
        dataType: DataType.Users,
        show: { visible: true },
        create: { visible: false },
        update: { visible: false },
      },
    ],
  },
];
